import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Reminder.module.scss";
import axios from "axios";
import Modal from "../Modal";
import Skeleton from "react-loading-skeleton";
import { generalActions } from "../../../../store/actions";
import {
  BASE_URL,
  URL_CLIENTS,
  URL_PROJECTS,
  URL_PORTFOLIO,
  URL_SEARCH_REQUEST,
  URL_RISK,
  URL_TASK,
  URL_SEARCH_TASK,
  URL_CLIENT_PROGRAMS,
  URL_SEARCH_USERS,
  URL_BUDGETS,
} from "../../../../store/services/URL";
import {
  AddIcon,
  CalendarIcon,
  MeetingsClockIcon,
} from "../../../../modules/default-svg";
import CustomButton from "../../../controls/button/Button";
import DropDown from "../../../controls/dropdown/DropdownFluent";
import {
  getLabelByType,
  reminderPriorityOptions,
} from "../../../../helpers/utils";
import userService from "../../../../store/services/user.service";
import generalService from "../../../../store/services/general.service";
import {
  loading,
  reminderDetail,
} from "../../../../store/selectors/general.selector";
import {
  clearReminder as clearReminderRequest,
  getNotifications,
  getReminders,
} from "../../../../store/actions/general.actions";
import Pencil from "../../../../assets/svg/pencil.svg";
import NotesIcon from "../../../../assets/svg/notes.svg";
import {
  Avatar,
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from "@fluentui/react-components";
import moment from "moment";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { X } from 'lucide-react';

export const ReminderModal = ({
  setIsModalOpen,
  selectedTag,
  type,
  isCreate,
}) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const notesInputRef = useRef(null);
  const priorityInputRef = useRef(null);
  const reminder = useSelector(reminderDetail);
  const [modalTitle, setModalTitle] = useState("");
  const [priority, setPriority] = useState(0);
  const [titleContent, setTitleContent] = useState("");
  const [dueDate, setDueDate] = useState(null);
  const [notesContent, setNotesContent] = useState("");
  const [resources, setResources] = useState([]);
  const [resourceOptions, setResourceOptions] = useState([]);
  const [assignedResources, setAssignedResources] = useState([]);
  const loader = useSelector(loading);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const settings = JSON.parse(localStorage.getItem("settings"));
  let dateFormat = settings?.regionalSettings?.dateFormat || "MM/dd/yyyy";
  const timeFormat = "HH:mm";
  const [recipientSearch, setRecipientSearch] = useState("");
  const [recipientPopoverOpen, setRecipientPopoverOpen] = useState(false);
  const [selectedDateTimeSuggestion, setSelectedDateTimeSuggestion] = useState(null);
  const [recipientSelectedIndex, setRecipientSelectedIndex] = useState(0);
  const [showMorePopoverOpen, setShowMorePopoverOpen] = useState(false);
  const recipientInputRef = useRef(null);
  const MAX_VISIBLE_RECIPIENTS = 5;

  // Title tagging states
  const [titlePopoverOpen, setTitlePopoverOpen] = useState(false);
  const [titleShowEntityTypes, setTitleShowEntityTypes] = useState(false);
  const [titleShowSearchResults, setTitleShowSearchResults] = useState(false);
  const [titleSelectedEntityType, setTitleSelectedEntityType] = useState(null);
  const [titleSearchResults, setTitleSearchResults] = useState([]);
  const [titleSelectedIndex, setTitleSelectedIndex] = useState(0);
  const [titleSearchQuery, setTitleSearchQuery] = useState('');
  const titleSearchInputRef = useRef(null);

  // Notes tagging states
  const [notesPopoverOpen, setNotesPopoverOpen] = useState(false);
  const [notesShowEntityTypes, setNotesShowEntityTypes] = useState(false);
  const [notesShowSearchResults, setNotesShowSearchResults] = useState(false);
  const [notesSelectedEntityType, setNotesSelectedEntityType] = useState(null);
  const [notesSearchResults, setNotesSearchResults] = useState([]);
  const [notesSelectedIndex, setNotesSelectedIndex] = useState(0);
  const [notesSearchQuery, setNotesSearchQuery] = useState('');
  const notesSearchInputRef = useRef(null);

  const dateTimeSuggestions = [
    { label: "In 1 hour", value: "1h" },
    { label: "In 3 hours", value: "3h" },
    { label: "Tomorrow 9 AM", value: "tomorrow9am" },
    { label: "In 1 week", value: "1w" },
  ];

  const entityTypes = [
    { id: 'User', display: 'User' },
    { id: 'Client', display: 'Client' },
    { id: 'Project', display: 'Project' },
    { id: 'Program', display: 'Program' },
    { id: 'Portfolio', display: 'Portfolio' },
    { id: 'ChangeRequest', display: 'Change Request' },
    { id: 'Risk', display: 'Risk' },
    { id: 'Budget', display: 'Budget' },
    { id: 'Scope', display: 'Scope' },
    { id: 'Task', display: 'Task' },
  ];

  useEffect(() => {
    if (titlePopoverOpen && titleSearchInputRef.current) {
      setTimeout(() => titleSearchInputRef.current?.focus(), 50);
    }
  }, [titlePopoverOpen, titleShowEntityTypes, titleShowSearchResults]);

  useEffect(() => {
    if (notesPopoverOpen && notesSearchInputRef.current) {
      setTimeout(() => notesSearchInputRef.current?.focus(), 50);
    }
  }, [notesPopoverOpen, notesShowEntityTypes, notesShowSearchResults]);

  const fetchEntityRecords = async (entityType, query = '') => {
    try {
      const token = localStorage.getItem("accessToken");
      const headers = {
        Authorization: `Bearer ${token.replace(/"/g, "")}`,
      };

      let url = '';
      switch (entityType.toLowerCase()) {
        case 'user':
          url = `${URL_SEARCH_USERS}${query}`;
          break;
        case 'client':
          url = `${URL_CLIENTS}?searchterm=${query}`;
          break;
        case 'project':
          url = `${URL_PROJECTS}?searchTerm=${query}`;
          break;
        case 'program':
          url = `${URL_CLIENT_PROGRAMS}?searchTerm=${query}`;
          break;
        case 'portfolio':
          url = `${URL_PORTFOLIO}?searchTerm=${query}`;
          break;
        case 'changerequest':
          url = `${URL_SEARCH_REQUEST}${query}`;
          break;
        case 'risk':
          url = `${URL_RISK}?searchTerm=${query}`;
          break;
        case 'budget':
          url = `${URL_BUDGETS}?searchTerm=${query}`;
          break;
        case 'scope':
          url = `${BASE_URL}Scopes?searchTerm=${query}`;
          break;
        case 'task':
          url = `${BASE_URL}Tasks?searchTerm=${query}`;
          break;
        default:
          return [];
      }

      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      console.error('Error fetching entity records:', error);
      return [];
    }
  };

  const handleTitleInput = (e) => {
    const content = e.target.innerHTML;
    setTitleContent(content);

    const text = e.target.innerText || '';
    const lastAtIndex = text.lastIndexOf('@');

    if (lastAtIndex !== -1 && lastAtIndex === text.length - 1) {
      setTitleShowEntityTypes(true);
      setTitleShowSearchResults(false);
      setTitlePopoverOpen(true);
      setTitleSelectedIndex(0);
      setTitleSearchQuery('');
    } else {
      setTitlePopoverOpen(false);
      setTitleShowEntityTypes(false);
      setTitleShowSearchResults(false);
    }
  };

  const handleNotesInput = (e) => {
    const content = e.target.innerHTML;
    setNotesContent(content);

    const text = e.target.innerText || '';
    const lastAtIndex = text.lastIndexOf('@');

    if (lastAtIndex !== -1 && lastAtIndex === text.length - 1) {
      setNotesShowEntityTypes(true);
      setNotesShowSearchResults(false);
      setNotesPopoverOpen(true);
      setNotesSelectedIndex(0);
      setNotesSearchQuery('');
    } else {
      setNotesPopoverOpen(false);
      setNotesShowEntityTypes(false);
      setNotesShowSearchResults(false);
    }
  };

  const insertEntityPill = (ref, entityType, record, setContent, closePopover) => {
    if (!ref.current) return;
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);

    const text = ref.current.innerHTML;
    const lastAtIndex = text.lastIndexOf('@');

    const beforeAt = text.substring(0, lastAtIndex);

    const pill = document.createElement('span');
    pill.className = 'reminder-entity-pill';
    pill.contentEditable = 'false';
    pill.setAttribute('data-type', entityType);
    pill.setAttribute('data-id', record.id);
    pill.textContent = record.fullName || record.name || record.code;

    const space = document.createTextNode('\u00A0');

    ref.current.innerHTML = beforeAt;
    ref.current.appendChild(pill);
    ref.current.appendChild(space);

    const newRange = document.createRange();
    newRange.setStartAfter(space);
    newRange.collapse(true);
    selection.removeAllRanges();
    selection.addRange(newRange);

    setContent(ref.current.innerHTML);
    closePopover();
    ref.current.focus();
  };

  const handleTitleEntityTypeSelect = async (entityType) => {
    setTitleSelectedEntityType(entityType);
    setTitleShowEntityTypes(false);
    setTitleShowSearchResults(true);
    setTitleSelectedIndex(0);
    setTitleSearchQuery('');

    const results = await fetchEntityRecords(entityType.id);
    setTitleSearchResults(results);
  };

  const handleNotesEntityTypeSelect = async (entityType) => {
    setNotesSelectedEntityType(entityType);
    setNotesShowEntityTypes(false);
    setNotesShowSearchResults(true);
    setNotesSelectedIndex(0);
    setNotesSearchQuery('');

    const results = await fetchEntityRecords(entityType.id);
    setNotesSearchResults(results);
  };

  const handleTitleSearchChange = async (e) => {
    const query = e.target.value;
    setTitleSearchQuery(query);
    setTitleSelectedIndex(0);

    if (titleShowSearchResults && titleSelectedEntityType) {
      const results = await fetchEntityRecords(titleSelectedEntityType.id, query);
      setTitleSearchResults(results);
    }
  };

  const handleNotesSearchChange = async (e) => {
    const query = e.target.value;
    setNotesSearchQuery(query);
    setNotesSelectedIndex(0);

    if (notesShowSearchResults && notesSelectedEntityType) {
      const results = await fetchEntityRecords(notesSelectedEntityType.id, query);
      setNotesSearchResults(results);
    }
  };

  const handleTitleRecordSelect = (record) => {
    insertEntityPill(
      inputRef,
      titleSelectedEntityType.id,
      record,
      setTitleContent,
      () => {
        setTitlePopoverOpen(false);
        setTitleShowSearchResults(false);
        setTitleSearchResults([]);
        setTitleSelectedEntityType(null);
      }
    );
  };

  const handleNotesRecordSelect = (record) => {
    insertEntityPill(
      notesInputRef,
      notesSelectedEntityType.id,
      record,
      setNotesContent,
      () => {
        setNotesPopoverOpen(false);
        setNotesShowSearchResults(false);
        setNotesSearchResults([]);
        setNotesSelectedEntityType(null);
      }
    );
  };

  const handleTitleKeyDown = (e) => {
    if (e.key === ' ' && !titlePopoverOpen) {
      e.preventDefault();
      document.execCommand('insertHTML', false, '&nbsp;');
      return;
    }

    if (!titlePopoverOpen) return;

    if (document.activeElement === titleSearchInputRef.current) {
      if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(e.key)) {
        return;
      }
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const maxIndex = titleShowEntityTypes
        ? getFilteredEntityTypes(titleSearchQuery).length - 1
        : titleSearchResults.length - 1;
      setTitleSelectedIndex(prev => prev < maxIndex ? prev + 1 : 0);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const maxIndex = titleShowEntityTypes
        ? getFilteredEntityTypes(titleSearchQuery).length - 1
        : titleSearchResults.length - 1;
      setTitleSelectedIndex(prev => prev > 0 ? prev - 1 : maxIndex);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (titleShowEntityTypes) {
        const filtered = getFilteredEntityTypes(titleSearchQuery);
        if (filtered[titleSelectedIndex]) {
          handleTitleEntityTypeSelect(filtered[titleSelectedIndex]);
        }
      } else if (titleShowSearchResults && titleSearchResults[titleSelectedIndex]) {
        handleTitleRecordSelect(titleSearchResults[titleSelectedIndex]);
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setTitlePopoverOpen(false);
      setTitleShowEntityTypes(false);
      setTitleShowSearchResults(false);
      setTitleSearchQuery('');
    }
  };

  const handleNotesKeyDown = (e) => {

    if (!notesPopoverOpen){
      if (e.key === ' ') {
        e.preventDefault();
        document.execCommand('insertHTML', false, '&nbsp;');
      }
      else if (e.key === 'Enter') {
        e.preventDefault();
        document.execCommand('insertHTML', false, '<br><br>');
      }
      return;
    }

    if (document.activeElement === notesSearchInputRef.current) {
      if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(e.key)) {
        return;
      }
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const maxIndex = notesShowEntityTypes
        ? getFilteredEntityTypes(notesSearchQuery).length - 1
        : notesSearchResults.length - 1;
      setNotesSelectedIndex(prev => prev < maxIndex ? prev + 1 : 0);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const maxIndex = notesShowEntityTypes
        ? getFilteredEntityTypes(notesSearchQuery).length - 1
        : notesSearchResults.length - 1;
      setNotesSelectedIndex(prev => prev > 0 ? prev - 1 : maxIndex);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (notesShowEntityTypes) {
        const filtered = getFilteredEntityTypes(notesSearchQuery);
        if (filtered[notesSelectedIndex]) {
          handleNotesEntityTypeSelect(filtered[notesSelectedIndex]);
        }
      } else if (notesShowSearchResults && notesSearchResults[notesSelectedIndex]) {
        handleNotesRecordSelect(notesSearchResults[notesSelectedIndex]);
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setNotesPopoverOpen(false);
      setNotesShowEntityTypes(false);
      setNotesShowSearchResults(false);
      setNotesSearchQuery('');
    }
  };

  const getFilteredEntityTypes = (query) => {
    if (!query) return entityTypes;
    return entityTypes.filter(et =>
      et.display.toLowerCase().includes(query.toLowerCase())
    );
  };

  const searchHandler = (value) => {
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
          image: obj.image
        }));
        setResourceOptions(transformedArray);
      })
      .catch(() => { });
  };

  const handleRecipientSearch = (value) => {
    setRecipientSearch(value);
    setRecipientSelectedIndex(0);
    if (value) {
      searchHandler(value);
      setRecipientPopoverOpen(true);
    } else {
      setRecipientPopoverOpen(false);
    }
  };

  const handleSelectRecipient = (recipient) => {
    if (!recipient) return;

    const isAlreadySelected = assignedResources.some(r => r.value === recipient.value);

    if (!isAlreadySelected) {
      const newRecipient = {
        label: recipient.label,
        value: recipient.value,
        image: recipient.image
      };
      const newAssignedResources = [...assignedResources, newRecipient];
      const newResources = [...resources, recipient.value];

      setAssignedResources(newAssignedResources);
      setResources(newResources);
    }

    setRecipientSearch("");
    setRecipientPopoverOpen(false);
    setResourceOptions([]);
    setRecipientSelectedIndex(0);

    // Focus back on input for easy multiple selections
    if (recipientInputRef.current) {
      setTimeout(() => recipientInputRef.current.focus(), 0);
    }
  };

  const handleRecipientKeyDown = (e) => {
    if (!recipientPopoverOpen || resourceOptions.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setRecipientSelectedIndex(prev =>
        prev < resourceOptions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setRecipientSelectedIndex(prev =>
        prev > 0 ? prev - 1 : resourceOptions.length - 1
      );
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (resourceOptions[recipientSelectedIndex]) {
        handleSelectRecipient(resourceOptions[recipientSelectedIndex]);
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setRecipientPopoverOpen(false);
      setRecipientSearch("");
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    dispatch(clearReminderRequest());
    setTitleContent("");
    setNotesContent("");
    setDueDate(null);
    setResources([]);
    setAssignedResources([]);
    setPriority(0);
  };

  const convertPillsToLinks = (html) => {
    return html.replace(
      /<span class="reminder-entity-pill"[^>]*data-type="([^"]+)"[^>]*data-id="([^"]+)"[^>]*>([^<]+)<\/span>/g,
      '<@link:$1:$2@>'
    );
  };

  const convertLinksToPills = (text) => {
    if (!text) return '';

    return text.replace(/<@link:(\w+):([a-f0-9\-]+)@>/g, (match, type, id) => {
      const link = reminder?.links?.find(l => l.linkId === id);
      const linkName = link?.linkName || type;
      return `<span class="reminder-entity-pill" contenteditable="false" data-type="${type}" data-id="${id}">${linkName}</span>`;
    });
  };

  const parseLinksFromHTML = (html) => {
    const links = [];
    const pillRegex = /<span class="reminder-entity-pill"[^>]*data-type="([^"]+)"[^>]*data-id="([^"]+)"[^>]*>([^<]+)<\/span>/g;
    let match;

    while ((match = pillRegex.exec(html)) !== null) {
      const [, linkType, linkId, linkName] = match;
      links.push({
        LinkId: linkId,
        LinkType: linkType,
        LinkName: linkName,
      });
    }

    return links;
  };

  const handleSave = () => {
    const titleWithLinks = convertPillsToLinks(titleContent);
    const notesWithLinks = convertPillsToLinks(notesContent);
    const extractedLinks = [...parseLinksFromHTML(titleContent), ...parseLinksFromHTML(notesContent)];

    const uniqueLinks = extractedLinks.filter(
      (value, index, self) =>
        index === self.findIndex((obj) => obj.LinkId === value.LinkId)
    );

    let utcString = null;
    if (dueDate) {
      utcString = moment(dueDate).utc().format();
    }

    const payload = {
      Title: titleWithLinks,
      Notes: notesWithLinks,
      Priority: priority || "Low",
      ...(utcString && {
        DueDate: utcString,
      }),
      Recipients: resources,
      Links: uniqueLinks,
    };

    setIsButtonLoading(true);
    if (reminder) {
      generalService
        .updateRemindersRequest({ id: reminder.id, payload: payload })
        .then((res) => {
          dispatch(getReminders());
          setIsModalOpen(false);
          dispatch(
            generalActions.showToast({
              title: "Reminder updated!",
              type: "success",
            })
          );
          setIsButtonLoading(false);
        })
        .catch((error) => {
          const {
            data: { errors },
          } = error;
          dispatch(
            generalActions.showToast({
              title: errors?.[0]?.message,
              type: "error",
            })
          );
          setIsButtonLoading(false);
        });
    } else {
      generalService
        .createRemindersRequest(payload)
        .then((res) => {
          dispatch(getReminders());
          setIsModalOpen(false);
          dispatch(
            generalActions.showToast({
              title: "Reminder created",
              type: "success",
            })
          );
          setIsButtonLoading(false);
        })
        .catch((error) => {
          const {
            data: { errors },
          } = error;
          dispatch(
            generalActions.showToast({
              title: errors?.[0]?.message,
              type: "error",
            })
          );
          setIsButtonLoading(false);
        });
    }
  };

  useEffect(() => {
    if (reminder) {
      const convertedTitle = convertLinksToPills(reminder.title);
      const convertedNotes = convertLinksToPills(reminder.notes);
      setTitleContent(convertedTitle);
      setNotesContent(convertedNotes);

      setTimeout(() => {
        if (inputRef.current && notesInputRef.current) {
          inputRef.current.innerHTML = convertedTitle;
          notesInputRef.current.innerHTML = convertedNotes;
        }
      }, 100);

      const arrResources = reminder?.recipients.map((r) => r.id);
      const arr = reminder?.recipients.map((r) => ({
        label: r.name,
        value: r.id,
        image: r.image,
        email: r.email,
        isExternal: r.isExternal,
        phoneNumber: r.phoneNumber,
        title: r.title,
      }));

      if (reminder.dueDate) {
        const localMoment = moment.utc(reminder.dueDate).local();
        setDueDate(localMoment.toDate());
      }

      setResources(arrResources);
      setAssignedResources(arr);
      setPriority(reminder.priority);
    }
    else if (selectedTag && type) {
      const convertedTitle = `<span class="reminder-entity-pill" contenteditable="false" data-type="${type}" data-id="${selectedTag.id}">${selectedTag.fullName || selectedTag.name || selectedTag.title  || selectedTag.code}</span>&nbsp;`;
      setTitleContent(convertedTitle);
      setPriority(0);
      const recipients = getSelectedTypeReceipients(selectedTag, type);
      const arrResources = recipients.map((r) => r.id);
      const arr = recipients.map((r) => ({
        label: r.name,
        value: r.id,
        image: r.image,
        email: r.email,
        isExternal: r.isExternal,
        phoneNumber: r.phoneNumber,
        title: r.title,
      }));
      setResources(arrResources);
      setAssignedResources(arr);
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.innerHTML = convertedTitle;
        }
      }, 100);
    }
    else {
      clearReminder();
    }
    setIsLoading(false);
  }, [reminder, selectedTag, type]);

  const getSelectedTypeReceipients = (item, type) => {
    let receipients = [];
    if (item && type) {
      switch (type) {
        case 'Project':
          receipients = item.owner ? [item.owner] : [];
          break;
      }
    }
    return receipients;
  }

  const clearReminder = () => {
    setTitleContent("");
    setNotesContent("");
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.innerHTML = "";
      }
      if (notesInputRef.current) {
        notesInputRef.current.innerHTML = "";
      }
    }, 100);

    setDueDate(null);
    setResources([]);
    setAssignedResources([]);
    setPriority(0);
  }

  useEffect(() => {
    if (loader) setIsLoading(true);
  }, [loader]);

  useEffect(() => {
    if (!isCreate) setModalTitle("Edit Reminder");
    else setModalTitle("Create Reminder");
  }, [isCreate]);

  const filterPassedTime = (time) => {
    if (!dueDate) return true;

    const selectedDate = moment(dueDate).format('YYYY-MM-DD');
    const today = moment().format('YYYY-MM-DD');

    if (selectedDate === today) {
      const currentTime = new Date();
      const selectedTime = new Date(time);
      return currentTime.getTime() < selectedTime.getTime();
    }

    return true;
  };

  const handleDateTimeSuggestionClick = (suggestion) => {
    setSelectedDateTimeSuggestion(suggestion.value);
    const now = moment();
    let newDateTime;

    switch (suggestion.value) {
      case "1h":
        newDateTime = now.add(1, 'hour');
        break;
      case "3h":
        newDateTime = now.add(3, 'hours');
        break;
      case "tomorrow9am":
        newDateTime = now.add(1, 'day').hour(9).minute(0);
        break;
      case "1w":
        newDateTime = now.add(1, 'week');
        break;
      default:
        newDateTime = now.add(1, 'hour');
    }

    setDueDate(newDateTime.toDate());
  };

  const handleRemoveRecipient = (recipientValue) => {
    setAssignedResources(assignedResources.filter(r => r.value !== recipientValue));
    setResources(resources.filter(id => id !== recipientValue));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (recipientInputRef.current && !recipientInputRef.current.contains(event.target)) {
        setRecipientPopoverOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getPriorityClass = (priorityValue) => {
    switch (priorityValue) {
      case 2:
        return 'high';
      case 1:
        return 'moderate';
      case 0:
      default:
        return 'low';
    }
  };

  const formBody = () => {
    const visibleRecipients = assignedResources.slice(0, MAX_VISIBLE_RECIPIENTS);
    const hiddenRecipients = assignedResources.slice(MAX_VISIBLE_RECIPIENTS);
    const hiddenRecipientsCount = assignedResources.length - MAX_VISIBLE_RECIPIENTS;
    const filteredTitleEntityTypes = getFilteredEntityTypes(titleSearchQuery);
    const filteredNotesEntityTypes = getFilteredEntityTypes(notesSearchQuery);

    return (
      <div className={styles.reminderFormWrapper}>
        {/* Title Input Section */}
        <div className={styles.formSection}>
          <Popover
            open={titlePopoverOpen}
            positioning="below-start"
            withArrow={false}
          >
            <PopoverTrigger disableButtonEnhancement>
              <div className={styles.inputWrapper}>
                <img src={Pencil} alt="" className={styles.inputIcon} />
                {isLoading ? (
                  <Skeleton height={42} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
                ) : (
                  <div
                    ref={inputRef}
                    contentEditable
                    onInput={handleTitleInput}
                    onKeyDown={handleTitleKeyDown}
                    className={styles.editableInput}
                    data-placeholder="Add title (Use '@' to tag records)"
                  />
                )}
              </div>
            </PopoverTrigger>
            <PopoverSurface className={styles.suggestionPopover}>
              <div className={styles.searchInputWrapper}>
                <input
                  ref={titleSearchInputRef}
                  type="text"
                  className={styles.searchInput}
                  placeholder={titleShowEntityTypes ? "Search entity types..." : `Search ${titleSelectedEntityType?.display || 'records'}...`}
                  value={titleSearchQuery}
                  onChange={handleTitleSearchChange}
                  onKeyDown={handleTitleKeyDown}
                />
              </div>
              {titleShowEntityTypes && (
                <div className={styles.suggestionContainer}>
                  <p className={styles.suggestionHead}>Select entity type</p>
                  <div className={styles.suggestionBody}>
                    {filteredTitleEntityTypes.map((entityType, index) => (
                      <span
                        key={entityType.id}
                        onClick={() => handleTitleEntityTypeSelect(entityType)}
                        className={index === titleSelectedIndex ? styles.selectedSuggestion : ''}
                      >
                        {entityType.display}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {titleShowSearchResults && (
                <div className={styles.suggestionContainer}>
                  <p className={styles.suggestionHead}>Select {titleSelectedEntityType?.display}</p>
                  <div className={styles.suggestionBody}>
                    {titleSearchResults.length > 0 ? (
                      titleSearchResults.map((record, index) => (
                        <span
                          key={record.id}
                          onClick={() => handleTitleRecordSelect(record)}
                          className={index === titleSelectedIndex ? styles.selectedSuggestion : ''}
                        >
                          {record.fullName || record.name || record.code}
                        </span>
                      ))
                    ) : (
                      <span className={styles.noResults}>No results found</span>
                    )}
                  </div>
                </div>
              )}
            </PopoverSurface>
          </Popover>
        </div>

        {/* Priority and DateTime Row */}
        <div className={styles.priorityDateTimeRow}>
          <div className={styles.dateTimeGroup}>
            <label className={styles.inputLabel}>Date & Time</label>
            <div className={styles.dateTimeInputs}>
              <div className={styles.dateInputWrapper}>
                <DatePicker
                  selected={dueDate}
                  onChange={(newDateTime) => {
                    setDueDate(newDateTime);
                    setSelectedDateTimeSuggestion(null);
                  }}
                  showTimeSelect
                  timeFormat={timeFormat}
                  timeIntervals={15}
                  dateFormat={`${dateFormat} ${timeFormat}`}
                  minDate={new Date()}
                  filterTime={filterPassedTime}
                  placeholderText="Select date & time"
                  className="dateTime-input"
                  popperClassName="react-datepicker-popper"
                  popperPlacement="bottom-start"
                  timeCaption="Time"
                  isClearable
                  disabled={isLoading}
                />
                {!dueDate && (
                  <div className={styles.dateTimeIcon}>
                    <CalendarIcon />
                  </div>
                )}
              </div>
            </div>

            <div className={styles.dateTimeSuggestions}>
              {dateTimeSuggestions.map((suggestion) => (
                <span
                  key={suggestion.value}
                  className={`${styles.suggestionChip} ${selectedDateTimeSuggestion === suggestion.value ? styles.selected : ''}`}
                  onClick={() => handleDateTimeSuggestionClick(suggestion)}
                >
                  {suggestion.label}
                </span>
              ))}
            </div>
          </div>
          <div className={styles.priorityGroup}>
            <label className={styles.inputLabel}>Priority</label>
            <div className={styles.priorityDropdownWrapper}>
              <DropDown
                showLabel={false}
                options={reminderPriorityOptions}
                defaultVal={getLabelByType("reminderPriority", priority)}
                onChange={setPriority}
                loading={isLoading}
                inputRef={priorityInputRef}
              />
            </div>
          </div>
        </div>

        {/* Advanced Options Section */}
        <div className={styles.formSection}>
          {/* Recipients Section */}
          <div className={styles.recipientsSection}>
            <label className={styles.recipientsLabel}>Recipients</label>
            <Popover
              open={recipientPopoverOpen}
              onOpenChange={(e, data) => setRecipientPopoverOpen(data.open)}
              positioning="below-start"
              withArrow={false}
            >
              <PopoverTrigger disableButtonEnhancement>
                <div className={styles.recipientsInputWrapper}>
                  <input
                    ref={recipientInputRef}
                    type="text"
                    className={styles.recipientsInput}
                    placeholder="Search and add recipients..."
                    value={recipientSearch}
                    onChange={(e) => handleRecipientSearch(e.target.value)}
                    onKeyDown={handleRecipientKeyDown}
                    onFocus={() => recipientSearch && setRecipientPopoverOpen(true)}
                  />
                </div>
              </PopoverTrigger>
              <PopoverSurface className={styles.suggestionPopover}>
                {resourceOptions.length > 0 && (
                  <div className={styles.suggestionContainer}>
                    <div className={styles.suggestionBody}>
                      {resourceOptions.map((recipient, index) => (
                        <div
                          key={recipient.value}
                          className={`${styles.recipientOption} ${index === recipientSelectedIndex ? styles.selectedRecipient : ''}`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleSelectRecipient(recipient);
                          }}
                          onMouseEnter={() => setRecipientSelectedIndex(index)}
                        >
                          <Avatar
                            size={16}
                            name={recipient.label}
                            image={{ src: recipient.image }}
                          />
                          <span className={styles.recipientName}>{recipient.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </PopoverSurface>
            </Popover>

            {assignedResources.length > 0 && (
              <div className={styles.selectedRecipients}>
                {visibleRecipients.map((recipient) => (
                  <div key={recipient.value} className={styles.recipientPill}>
                    <Avatar
                      size={20}
                      name={recipient.label}
                      image={{ src: recipient.image }}
                      className={styles.pillAvatar}
                    />
                    <span className={styles.pillName}>{recipient.label}</span>
                    <button
                      className={styles.pillRemove}
                      onClick={() => handleRemoveRecipient(recipient.value)}
                      type="button"
                    >
                      <X size={12} />
                    </button>
                  </div>
                ))}
                {hiddenRecipientsCount > 0 && (
                  <Popover
                    open={showMorePopoverOpen}
                    onOpenChange={(e, data) => setShowMorePopoverOpen(data.open)}
                    positioning="below-start"
                    withArrow={false}
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <div className={styles.showMorePill}>
                        +{hiddenRecipientsCount} more
                      </div>
                    </PopoverTrigger>
                    <PopoverSurface className={styles.suggestionPopover}>
                      <div className={styles.suggestionContainer}>
                        <p className={styles.suggestionHead}>All Recipients ({assignedResources.length})</p>
                        <div className={styles.suggestionBody}>
                          {hiddenRecipients.map((recipient) => (
                            <div key={recipient.value} className={styles.recipientOption}>
                              <Avatar
                                size={16}
                                name={recipient.label}
                                image={{ src: recipient.image }}
                              />
                              <span className={styles.recipientName}>{recipient.label}</span>
                              <button
                                className={styles.pillRemoveInPopover}
                                onClick={() => {
                                  handleRemoveRecipient(recipient.value);
                                  if (hiddenRecipients.length === 1) {
                                    setShowMorePopoverOpen(false);
                                  }
                                }}
                                type="button"
                              >
                                <X size={10} />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </PopoverSurface>
                  </Popover>
                )}
              </div>
            )}
          </div>
          {/* Notes Section */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Notes</label>
            <Popover
              open={notesPopoverOpen}
              positioning="below-start"
              withArrow={false}
            >
              <PopoverTrigger disableButtonEnhancement>
                <div className={styles.inputWrapper}>
                  <img src={NotesIcon} alt="" className={styles.inputIcon} />
                  {isLoading ? (
                    <Skeleton height={90} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
                  ) : (
                    <div
                      ref={notesInputRef}
                      contentEditable
                      onInput={handleNotesInput}
                      onKeyDown={handleNotesKeyDown}
                      className={`${styles.editableInput} ${styles.textAreaInput}`}
                      data-placeholder="Add notes (Use '@' to tag records)"
                    />
                  )}
                </div>
              </PopoverTrigger>
              <PopoverSurface className={styles.suggestionPopover}>
                <div className={styles.searchInputWrapper}>
                  <input
                    ref={notesSearchInputRef}
                    type="text"
                    className={styles.searchInput}
                    placeholder={notesShowEntityTypes ? "Search entity types..." : `Search ${notesSelectedEntityType?.display || 'records'}...`}
                    value={notesSearchQuery}
                    onChange={handleNotesSearchChange}
                    onKeyDown={handleNotesKeyDown}
                  />
                </div>
                {notesShowEntityTypes && (
                  <div className={styles.suggestionContainer}>
                    <p className={styles.suggestionHead}>Select entity type</p>
                    <div className={styles.suggestionBody}>
                      {filteredNotesEntityTypes.map((entityType, index) => (
                        <span
                          key={entityType.id}
                          onClick={() => handleNotesEntityTypeSelect(entityType)}
                          className={index === notesSelectedIndex ? styles.selectedSuggestion : ''}
                        >
                          {entityType.display}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {notesShowSearchResults && (
                  <div className={styles.suggestionContainer}>
                    <p className={styles.suggestionHead}>Select {notesSelectedEntityType?.display}</p>
                    <div className={styles.suggestionBody}>
                      {notesSearchResults.length > 0 ? (
                        notesSearchResults.map((record, index) => (
                          <span
                            key={record.id}
                            onClick={() => handleNotesRecordSelect(record)}
                            className={index === notesSelectedIndex ? styles.selectedSuggestion : ''}
                          >
                            {record.fullName || record.name || record.code}
                          </span>
                        ))
                      ) : (
                        <span className={styles.noResults}>No results found</span>
                      )}
                    </div>
                  </div>
                )}
              </PopoverSurface>
            </Popover>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      title={`${modalTitle}`}
      handleCancel={handleCloseModal}
      handleSave={handleSave}
      body={formBody()}
      isLoading={isButtonLoading}
      size="small"
      saveBtnLabel="Save"
      cancelBtnLabel="Cancel"
      zIndex={true}
    />
  );
};

export default ReminderModal;